import React from "react";

const More = () => {
  return (
    <>
      <section class="get-more">
        <div class="container">
          <div class="getmore-wrap">
            <div class="getmore-content">
              {/* <!-- Left --> */}
              <div class="getmore-left">
                <h2>
                  Get more out of <br />
                  <span>vayosia.com </span>
                  with our mobile app
                </h2>

                <p>
                  Download the mobile app for one-touch access to your next
                  travel adventure. Get exclusive deals and secure bookings.
                </p>

                <div class="get-more-list">
                  <div>
                    <div class="icon">{/* <!-- SVG --> */}</div>
                    <h5>Exclusive Deals</h5>
                  </div>

                  <div>
                    <div class="icon"></div>
                    <h5>Easy Access</h5>
                  </div>

                  <div>
                    <div class="icon"></div>
                    <h5>Secure Booking</h5>
                  </div>

                  <div>
                    <div class="icon"></div>
                    <h5>24/7 Support</h5>
                  </div>
                </div>

                <div class="app-download">
                  <div class="qr-code">
                    <img src="qr.png" />
                  </div>

                  <div class="store-btns">
                    <a href="#">
                      <img src="assets/images/app-store.png" />
                    </a>
                    <a href="#">
                      <img src="assets/images/Google_Play_Store.png" />
                    </a>
                  </div>
                </div>
              </div>

              {/* <!-- Center --> */}
              {/* <div class="getmore-phone">
                <img src="mobile.png" />
              </div> */}

              {/* <!-- Right --> */}
              <div class="getmore-right">
                <img src="travel.png" />

                <img class="airplane one" src="plane.svg" />
                <img class="airplane two" src="plane.svg" />
              </div>
            </div>
          </div>

          <div className="get-more-details">
            <div className="row">
              <div className="col-md-6 col-xl-3">
                <div className="get-more-details-card">
                  <div className="icon"></div>
                  <div>
                    <h4>Best Price Guarantee</h4>
                    <p>
                      Get the best deals <br /> on every booking
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="get-more-details-card">
                  <div className="icon"></div>
                  <div>
                    <h4>24/7 Customer Support</h4>
                    <p>
                      We're here to help <br /> you anytime
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="get-more-details-card">
                  <div className="icon"></div>
                  <div>
                    <h4>Secure Payments</h4>
                    <p>
                      Safe, secure & <br /> hassle-free
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="get-more-details-card">
                  <div className="icon"></div>
                  <div>
                    <h4>Trusted by Millions</h4>
                    <p>
                      over 1M+ happy <br /> travelers
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default More;
